/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export * from './breakpoints/break-point';
export * from './breakpoints/break-point-registry';
export * from './breakpoints/break-points';
export * from './observable-media-service';
export * from './match-media';
export * from './media-change';
export * from './media-monitor';
export * from './_module';
//# sourceMappingURL=/usr/local/google/home/mmalerba/flex-layout/src/lib/media-query/index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/flex-layout/media-query/index.js
// module id = 1199
// module chunks = 3